export default __webpack_public_path__ + "static/media/035-map location.86cf7f8a.svg";